<template>
  <ul :class="$style.list">
    <li v-for="index in count" :key="index" :class="$style.card">
      <div :class="$style.body">
        <div :class="$style.media" />
        <div :class="$style.content">
          <div :class="$style.badge" />
          <div :class="$style.name" />
          <div :class="$style.metaRow">
            <div :class="$style.metaChip" />
            <div :class="$style.metaChip" />
          </div>
          <div :class="$style.kpiList">
            <div
              v-for="kpiIndex in KPI_LOADERS_COUNT"
              :key="kpiIndex"
              :class="$style.kpi"
            />
            <div :class="$style.leaderboardBtn" />
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
defineOptions({
  name: 'PickemTournamentsSkeletonList'
})

withDefaults(
  defineProps<{
    count?: number
  }>(),
  {
    count: 3
  }
)

const KPI_LOADERS_COUNT = 3
</script>

<style module lang="scss">
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeletonItem {
  background: var-default(--skeleton-item-bg);
  border-radius: 0.8em;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      to right,
      transparent,
      hsla(0deg, 0%, 100%, 0.3),
      transparent
    );
    animation: shimmer 1.5s infinite;
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1.6em;
  cursor: wait;
}

.card {
  padding: 2.4em;
  border-radius: 1.6em;
  background-color: color-get(--root-rgb-bg-tone-dark);

  @include down(md) {
    padding: 0;
    overflow: hidden;
  }
}

.body {
  display: flex;
  gap: 2.4em;
  align-items: flex-start;

  @include down(md) {
    flex-direction: column;
    gap: 0;
  }
}

.media {
  @extend .skeletonItem;
  flex-shrink: 0;
  width: 25.4em;
  height: 12em;

  @include down(md) {
    width: 100%;
    border-radius: 0.8em 0.8em 0 0;
  }
}

.content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  height: 12em;
  justify-content: space-between;

  @include down(md) {
    width: 100%;
    height: auto;
    gap: 1.2em;
    padding: 1.2em 1.6em;
  }
}

.badge {
  @extend .skeletonItem;
  display: none;
  width: 8em;
  height: 1.8em;
  border-radius: 0.4em;

  @include down(md) {
    display: block;
  }
}

.name {
  @extend .skeletonItem;
  width: 28em;
  height: 4em;
  border-radius: 0.6em;

  @include up(md) {
    order: 2;
  }

  @include down(md) {
    width: 100%;
    height: 2.8em;
  }
}

.metaRow {
  display: flex;
  flex-wrap: wrap;
  gap: 1.6em;
}

.metaChip {
  @extend .skeletonItem;
  width: 4.4em;
  height: 1.6em;
  border-radius: 0.4em;

  &:last-of-type {
    width: 16em;
  }

  @include down(md) {
    height: 1.4em;
  }
}

.kpiList {
  display: flex;
  align-items: center;
  gap: 2.4em;
  order: 3;

  @include down(md) {
    gap: 0.8em;
  }
}

.kpi {
  @extend .skeletonItem;
  width: 7em;
  height: 4.4em;
  border-radius: 0.4em;

  @include down(md) {
    width: 5em;
  }
}

.leaderboardBtn {
  @extend .skeletonItem;
  width: 12em;
  height: 4.4em;
  margin-left: auto;
  border-radius: 3em;

  @include down(md) {
    width: 4.4em;
    height: 4.4em;
  }
}
</style>
